// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.booker__select .sk-select__description {\n  min-height: 18px;\n}\n@media (max-width: 768px) {\n.booker__select .sk-select__description {\n    min-height: 11px;\n}\n}\n", ""]);
// Exports
module.exports = exports;
